/* eslint-disable @next/next/link-passhref */
import {
  Grid,
  IconButton,
  Typography,
  ButtonBaseProps,
  ButtonBase,
} from '@material-ui/core';
import React, { ReactNode } from 'react';
import useStyles from './styles';
import NavigateNextRoundedIcon from '@material-ui/icons/NavigateNextRounded';
import Image from 'next/image';
import Link from 'next/link';
import useTranslation from 'hooks/useTranslation';

// import { Container } from './styles';

interface CardProps extends ButtonBaseProps {
  src: any;
  title: string;
  description: string;
  breve?: boolean;
}
const OtherDrawsCard: React.FC<CardProps> = ({
  src,
  title,
  description,
  breve,
  ...rest
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <ButtonBase
      {...rest}
      className={classes.Container}
      style={{ cursor: breve ? 'auto' : 'pointer' }}
    >
      <div className={classes.title}>
        <div>
          <div className={classes.imageBox}>
            <Image src={src} alt="none" width={48} height={48} />
          </div>
          <Typography variant="h3">{title}</Typography>
        </div>
        {/* <IconButton> */}
        <NavigateNextRoundedIcon />
        {/* </IconButton> */}
      </div>
      <div className={classes.description}>
        <Typography variant="body2">{description}</Typography>
      </div>
      {breve && (
        <Typography variant="body1" className={classes.soon}>
          {t('soon')}
        </Typography>
      )}
    </ButtonBase>
  );
};

export default OtherDrawsCard;
